// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__238hM","Social":"Footer_Social__1TBls"};